import React from 'react';

import { AppLink, routeNaming } from '../../routes';
import { constants } from '../../config';
import compassIcon from './compass-icon.svg';
import xmartlabsLogo from './xmartlabs-logo.svg';
import facebook from '../../assets/images/facebook.png';
import instagram from '../../assets/images/instagram.png';
import youtube from '../../assets/images/youtube.png';
import styles from './Footer.css';

const officeGoogleMapsLinks = {
  main: 'https://www.google.com.uy/maps/place/Carlos+Gutierrez/@-34.9046844,-56.1866342,15z/data=!4m5!3m4!1s0x0:0xfa432699208dd307!8m2!3d-34.9046844!4d-56.1866342',
  branch18: 'https://www.google.com/maps/place/Carlos+Gutierrez/@-34.9050699,-56.1859164,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x2afec1884304f1cc!8m2!3d-34.9050699!4d-56.1837277?hl=es',
};

const renderPhoneSection = (className = '') => (
  <div className={[styles.section, className].join(' ')}>
    <ul className={styles.linkList}>
      <li>
        <a href={`tel:${constants.contactPhoneNumber.value}`} className={styles.phoneNumber}>
          Tel.: {constants.contactPhoneNumber.text}
        </a>
      </li>
    </ul>
    <ul className={styles.socialNetwork}>
      <li><a href="https://www.facebook.com/carlosgutierrez.oficialOK" target="_blank" rel="noopener noreferrer"><img src={facebook} alt="" /></a></li>
      <li><a href="https://www.instagram.com/carlosgutierrez.oficial" target="_blank" rel="noopener noreferrer"><img src={instagram} alt="" /></a></li>
      <li><a href="https://www.youtube.com/@CarlosGutierrezSA" target="_blank" rel="noopener noreferrer"><img src={youtube} alt="" /></a></li>
    </ul>
  </div>
);

const renderNavigationButton = link => (
  <a
    className={styles.navigationButton}
    href={link}
    rel="noopener noreferrer"
    target="_blank"
  >
    <img className={styles.navigationIcon} src={compassIcon} alt="" />
    <span>
      Navegar
    </span>
  </a>
);

const Footer = () => (
  <div className={styles.container}>
    <div className={styles.internalContainer}>
      <div className={styles.dataContainer}>
        {renderPhoneSection(styles.mobilePhoneSection)}
        <div className={styles.section}>
          <h3 className={styles.locationHeader}>Casa central</h3>
          <p className={styles.text}>
            Colonia 1372 esq. Ejido
            &nbsp;
            <a
              className={styles.mapLink}
              href={officeGoogleMapsLinks.main}
              rel="noopener noreferrer"
              target="_blank"
            >
              mapa
            </a>
          </p>
          <p className={styles.text}>
            Lun. a Vie. 9:00 - 19:00hs
          </p>
          <p className={styles.text}>
            Sab. 9:00 - 13:00hs
          </p>
          <p className={styles.text}>
            Estacionamiento en Torre de los Profesionales: Yaguarón 1411 entre Colonia y Mercedes
          </p>
          {renderNavigationButton(officeGoogleMapsLinks.main)}
          <h3 className={styles.locationHeader}>Sucursal 18</h3>
          <p className={styles.text}>
            18 de Julio 1486 esq. Vázquez
            &nbsp;
            <a
              className={styles.mapLink}
              href={officeGoogleMapsLinks.branch18}
              rel="noopener noreferrer"
              target="_blank"
            >
              mapa
            </a>
          </p>
          <p className={styles.text}>
            Lun. a Vie. 9:00 - 19:00hs
          </p>
          <p className={styles.text}>
            Sab. 9:00 - 13:00hs
          </p>
          {renderNavigationButton(officeGoogleMapsLinks.branch18)}
        </div>
        <div className={styles.section}>
          <h3 className={styles.locationHeader}>Nuestra empresa</h3>
          <ul className={styles.linkList}>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.ABOUT_US}
              >
                Quienes somos
              </AppLink>
            </li>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.VENUES_AND_OPEN_HOURS}
              >
                Locales y horarios
              </AppLink>
            </li>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.PANAVOX_SERVICE}
              >
                Servicio {constants.panavoxLigature}
              </AppLink>
            </li>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.BRAND_SERVICE}
              >
                Servicio Bronx
              </AppLink>
            </li>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.JOIN_OUR_TEAM}
              >
                Unirse a nuestro equipo
              </AppLink>
            </li>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.CONTACT}
              >
                Contacto
              </AppLink>
            </li>
          </ul>
        </div>
        <div className={styles.section}>
          <h3 className={styles.locationHeader}>Servicio al cliente</h3>
          <ul className={styles.linkList}>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.HELP}
              >
                Ayuda
              </AppLink>
            </li>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.SHIPPING}
              >
                Envíos
              </AppLink>
            </li>
            <li>
              <AppLink
                className={styles.link}
                routeName={routeNaming.SERVICE_TRACKING}
              >
                Seguimiento de servicios
              </AppLink>
            </li>
            <li>
              {/* <a
                rel="noopener noreferrer"
                target="_blank"
                className={styles.link}
                href="https://www.carlosgutierrez.com.uy/tycwebcg.htm"
              >Términos y Condiciones
              </a> */}
              <AppLink
                className={styles.link}
                routeName={routeNaming.CONDITIONS}
              >
                Términos y Condiciones
              </AppLink>
            </li>
            <li>
              <a
                className={styles.link}
                target="_blank"
                rel="noopener noreferrer"
                href={constants.ticketVerificationURL}
              >
                Verificar comprobante
              </a>
            </li>
          </ul>
        </div>
        {renderPhoneSection(styles.desktopPhoneSection)}
      </div>
      <div className={styles.bottomContainer}>
        <p className={styles.copyright}>
          Carlos Gutiérrez© Todos los derechos reservados - v1.9.6
        </p>
        <p className={styles.signature}>
          Sitio por &nbsp;
          <a
            href="https://www.xmartlabs.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img className={styles.signatureLogo} src={xmartlabsLogo} alt="" />
            &nbsp;
            Xmartlabs
          </a>
        </p>
      </div>
    </div>
  </div>
);

export { Footer };



// WEBPACK FOOTER //
// ./src/common/footer/Footer.jsx